"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GradeDataManager = void 0;
const react_1 = __importDefault(require("react"));
const moment_1 = __importDefault(require("moment"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const common_1 = require("../../../../../common");
const option_1 = require("../../../../../common/option");
const GlobalStateProvider_1 = require("../../../../../GlobalStateProvider");
const server_1 = require("../../../../../server");
const DeletePopUpLayout_1 = require("../../../../base/layout/DeletePopUpLayout");
const popup_1 = require("../../../../base/popup");
const SubjectCodes_1 = require("./SubjectCodes");
const GradeDataManagerStyled = styled_components_1.default.div `
	display: flex;
	flex-direction: column;
	gap: 20px;

	.section-block,
	.saved-data-card {
		background: var(--color-white, #ffffff);
		border-radius: 12px;
		padding: 18px 20px;
		display: flex;
		flex-direction: column;
		gap: 14px;
	}

	.section-title {
		color: var(--color-black, #101010);
		font-size: ${({ $isMobile }) => ($isMobile ? '16px' : '20px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '20px' : '30px')};
		font-weight: 700;
	}

	.upload-title-row,
	.saved-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 12px;
		flex-wrap: wrap;
	}

	.upload-title-row {
		justify-content: flex-start;
	}

	.upload-action-links {
		display: flex;
		align-items: center;
		gap: 20px;
		flex-wrap: wrap;
	}

	.upload-action-link {
		border: none;
		background: transparent;
		padding: 0;
		text-decoration: underline;
		color: var(--color-grey, #666666);
		font-size: ${({ $isMobile }) => ($isMobile ? '10px' : '14px')};
		line-height: ${({ $isMobile }) => ($isMobile ? '12px' : '22px')};
		cursor: pointer;
		display: inline-flex;
		align-items: center;
		gap: 4px;
	}

	.state-text,
	.todo-text,
	.saved-at,
	.helper-text,
	.error-text {
		font-size: 13px;
		line-height: 20px;
	}

	.state-text,
	.todo-text,
	.helper-text {
		color: var(--color-grey-l, #83868a);
	}

	.saved-at {
		color: var(--color-grey-l, #83868a);
		align-self: flex-end;
		margin-left: auto;
	}

	.state-text {
		font-weight: 500;
	}

	// .upload-file-attach .sample-file-download {
	// 	display: none !important;
	// }

	${({ $hasError }) => $hasError && `
		.upload-file-attach .file-wrap {
			border-color: #d1416f;
		}
	`}

	// .upload-file-attach .empty_file {
	// 	border-color: var(--color-grey-c, #e6e8ed);
	// 	background: #f6f7fb;
	// }

	.action-row {
		display: flex;
		align-items: center;
		justify-content: flex-end;
		gap: 10px;
	}

	.info-wrap {
		display: flex;
		justify-content: space-between;
	}

	.error-text {
		color: #d1416f;
		font-weight: 500;
	}

	.saved-table {
		width: auto;
		border-collapse: collapse;
		border-top: 1px solid var(--color-grey-w, #b6bac0);
	}

	.saved-table thead tr {
		background: var(--color-silver, #f3f4f8);
	}

	.saved-table th {
		padding: 10px 16px;
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 28px;
		font-weight: 500;
		color: var(--color-grey, #666666);
		white-space: nowrap;
		border-right: 1px solid var(--color-grey-w, #b6bac0);
		border-bottom: 1px solid var(--color-grey-w, #b6bac0);
	}

	.saved-table th:last-child {
		border-right: none;
	}

	.question-stats-table {
		width: auto;
		min-width: 560px;
		border-collapse: collapse;
		border-top: 1px solid var(--color-grey-w, #b6bac0);
	}

	.question-stats-table thead tr {
		background: var(--color-silver, #f3f4f8);
	}

	.question-stats-table th {
		padding: 8px 12px;
		text-align: center;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 24px;
		font-weight: 500;
		color: var(--color-grey, #666666);
		white-space: nowrap;
		width: 70px;
		vertical-align: middle;
		border-bottom: 1px solid var(--color-grey-w, #b6bac0);
		border-right: 1px solid var(--color-grey-w, #b6bac0);
	}

	.question-stats-table th:last-child {
		border-right: none;
	}

	.question-stats-table thead tr:last-child th {
		border-top: 1px solid var(--color-grey-w, #b6bac0);
	}

	.question-stats-table td {
		padding: 10px 12px;
		border-bottom: 1px solid var(--color-grey-w, #b6bac0);
		border-right: 1px solid var(--color-grey-w, #b6bac0);
		text-align: center;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 28px;
		font-weight: 400;
		color: var(--color-black, #101010);
	}

	.question-stats-table td:last-child {
		border-right: none;
	}

	.question-stats-table .subject-cell {
		white-space: normal;
		word-break: keep-all;
		text-align: center;
	}

	.table-scroll-wrap {
		overflow-x: auto;
	}

	.preview-grid {
		display: flex;
		flex-wrap: wrap;
		gap: 16px;
		align-items: flex-start;

		.saved-data-card {
			flex: 0 0 auto;
		}
	}

	${({ $isMobile }) => $isMobile && `
		.preview-grid .saved-data-card {
			flex: 1 1 100%;
			width: 100%;
		}
	`}

	/* Mobile: 수능예상점수 card list */
	.mobile-cutoff-list {
		display: flex;
		flex-direction: column;
	}

	.mobile-cutoff-group {
		padding: 10px 0;
		border-bottom: 1px solid var(--color-grey-w, #b6bac0);
	}

	.mobile-cutoff-group:last-child {
		border-bottom: none;
		padding-bottom: 0;
	}

	.mobile-cutoff-subject {
		font-size: 13px;
		font-weight: 700;
		color: var(--color-black, #101010);
		margin-bottom: 6px;
	}

	.mobile-cutoff-tier-row {
		display: flex;
		gap: 16px;
		padding: 3px 0;
		font-size: 13px;
		color: var(--color-black, #101010);
	}

	.mobile-cutoff-label {
		color: var(--color-grey, #666666);
		min-width: 36px;
	}

	/* Mobile: 문항별 분석 card list */
	.mobile-question-list {
		display: flex;
		flex-direction: column;
		gap: 10px;
	}

	.mobile-question-group {
		border: 1px solid var(--color-grey-w, #b6bac0);
		border-radius: 8px;
		overflow: hidden;
	}

	.mobile-question-group-header {
		padding: 8px 12px;
		background: var(--color-silver, #f3f4f8);
		font-size: 13px;
		font-weight: 700;
		color: var(--color-black, #101010);
	}

	.mobile-question-item {
		display: flex;
		flex-direction: column;
		gap: 6px;
		padding: 10px 12px;
		border-top: 1px solid var(--color-grey-w, #b6bac0);
	}

	.mobile-question-header {
		display: flex;
		align-items: baseline;
		gap: 10px;
		font-size: 13px;
	}

	.mobile-question-num {
		font-weight: 700;
		color: var(--color-black, #101010);
		white-space: nowrap;
	}

	.mobile-question-meta {
		color: var(--color-grey, #666666);
	}

	.mobile-choices-grid {
		display: flex;
		font-size: 13px;
	}

	.mobile-choice-item {
		flex: 1;
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2px;
	}

	.mobile-choice-label {
		color: var(--color-grey, #666666);
	}

	.saved-table td {
		padding: 10px 16px;
		border-bottom: 1px solid var(--color-grey-w, #b6bac0);
		border-right: 1px solid var(--color-grey-w, #b6bac0);
		text-align: left;
		font-family: 'Noto Sans KR', sans-serif;
		font-size: 14px;
		line-height: 28px;
		font-weight: 400;
		color: var(--color-black, #101010);
		vertical-align: middle;
	}

	.saved-table td:last-child {
		border-right: none;
	}

	.success-toast {
		position: fixed;
		left: ${({ $isMobile }) => ($isMobile ? '16px' : '48px')};
		bottom: ${({ $isMobile }) => ($isMobile ? '16px' : '48px')};
		z-index: 1000;
		display: inline-flex;
		align-items: center;
		gap: 10px;
		background: #4d4d4d;
		color: #ffffff;
		border-radius: 12px;
		padding: 19px 24px;
		font-size: 18px;
		line-height: 26px;
		font-weight: 500;
		box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
	}

	${({ $isMobile }) => ($isMobile && `
		.file-container {
			flex-direction: column;
		}

		.file-button-wrap {
			width: 100%;

			.teacher-grade-data-upload {
				display: flex;	
				flex: 1;
			}

			button {
				flex: 1;
			}
		}
		`)}
`;
exports.GradeDataManager = react_1.default.memo(({ testId, savedRows, savedAt, questionStatsSavedRows, restoredCutoff, onSaveSuccess, reportType, reportName, gradeReport, }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const { isMobile, isDesktop } = (0, GlobalStateProvider_1.useGlobalState)();
    const [fileList, setFileList] = react_1.default.useState([]);
    const [saveState, setSaveState] = react_1.default.useState('idle');
    const [showSuccessToast, setShowSuccessToast] = react_1.default.useState(false);
    const [errorMessage, setErrorMessage] = react_1.default.useState('');
    const reportTypeDisplay = react_1.default.useMemo(() => {
        if (reportType === 'gmk') {
            return '강대모의고사K';
        }
        if (reportType === 'yigam') {
            return '이감 모의고사';
        }
        if (reportType === 'etc') {
            // 상세유형명(reportName)은 등록 시 선택한 상세 유형명.
            // 상세유형 미선택 시 서버가 '기타'(또는 빈값)로 내려오며, 이 경우 '기타 -' 접두 없이 '기타 성적표'로만 표기.
            const trimmedName = typeof reportName === 'string' ? reportName.trim() : '';
            const hasDetail = trimmedName !== '' && trimmedName !== '기타';
            // 회차별 성적 포함 여부: gradeReport 미지정(undefined) 시 기본 포함 처리.
            const gradeLabel = gradeReport === false ? '회차별 성적 미포함' : '회차별 성적 포함';
            const baseTitle = hasDetail ? `기타 - ${trimmedName}` : '기타 성적표';
            return `${baseTitle} (${gradeLabel})`;
        }
        // 그 외(미지정 등) 유형은 라벨 미노출.
        return null;
    }, [reportType, reportName, gradeReport]);
    const hasSavedData = savedRows.length > 0 || (restoredCutoff?.length ?? 0) > 0;
    const hasSavedQuestionStats = questionStatsSavedRows.length > 0;
    // 마지막 저장일 표시 여부: savedAt 은 부모에서 report_data_saved 를 'YYYY-MM-DD HH:mm' 로 포맷한 문자열.
    // 등록된 성적표가 없으면 서버가 zero-date(0001-01-01)를 내려줘 '0001-01-01 00:00' 같은 빈값 아닌 문자열이 되므로,
    // 빈값/유효하지 않은 날짜/zero-date(year<=1)는 미표시. (savedRows 는 초기 로드 시 비어 판단 불가하므로 savedAt 자체로 판정)
    const hasValidSavedAt = react_1.default.useMemo(() => {
        if (!savedAt)
            return false;
        const m = (0, moment_1.default)(savedAt);
        return m.isValid() && m.year() > 1;
    }, [savedAt]);
    const isSaving = saveState === 'saving';
    // 검토 이상(에러) 상태에서는 [저장] 버튼 비활성. (파일 재업로드/제거 시 에러 해제됨 — useEffect 참고)
    const isSaveDisabled = fileList.length === 0 || isSaving || saveState === 'error';
    // Build 문항별 분석 preview rows, grouped by 과목.
    // row[0]은 두 형태를 수용: ①업로드 raws 의 숫자 과목코드('01' 등 — 표시명으로 변환)
    // ②question-stats API 복원의 표시명("선택 - 언어와매체", "공통" 등 — '선택 - ' 접두만 정리).
    const questionStatsGrouped = react_1.default.useMemo(() => {
        const rows = questionStatsSavedRows
            .filter(row => {
            const code = row[0];
            if (typeof code !== 'string')
                return false;
            const trimmed = code.trim();
            // 헤더 행('과목코드')과 빈값 제외
            return trimmed !== '' && trimmed !== '과목코드';
        })
            .map(row => {
            const raw = String(row[0]).trim();
            const isCode = /^\d+$/.test(raw);
            const subjectCode = isCode ? raw.padStart(2, '0') : raw;
            return {
                subjectCode,
                subjectName: isCode
                    ? (0, SubjectCodes_1.getSubjectDisplayName)(subjectCode)
                    : raw.replace(/^선택\s*-\s*/, ''),
                questionNum: row[1],
                correctRate: row[2],
                rank: row[3] != null ? row[3] : null,
                choices: [row[4] ?? null, row[5] ?? null, row[6] ?? null, row[7] ?? null, row[8] ?? null],
            };
        });
        const groupMap = new Map();
        for (const row of rows) {
            const existing = groupMap.get(row.subjectCode) ?? [];
            existing.push(row);
            groupMap.set(row.subjectCode, existing);
        }
        return Array.from(groupMap.entries())
            .sort(([a], [b]) => a.localeCompare(b, 'ko'))
            .map(([subjectCode, groupRows]) => ({
            subjectCode,
            subjectName: groupRows[0]?.subjectName || subjectCode,
            rows: groupRows.sort((a, b) => Number(a.questionNum) - Number(b.questionNum)),
        }));
    }, [questionStatsSavedRows]);
    // Build condensed preview: lowest 원점수 per (과목코드, 예상등급)
    // 업로드 직후에는 raws(savedRows, 과목별)로 계산하고, 재진입 복원 시에는 tier-cutoff 기반
    // restoredCutoff(과목 구분 없음, score 범위 문자열 가능)를 그대로 표시한다.
    const previewTableRows = react_1.default.useMemo(() => {
        // Skip header row (first row if it contains '과목코드' as a string)
        const dataRows = savedRows.filter(row => {
            const first = row[0];
            return !(typeof first === 'string' && first.trim() === '과목코드');
        });
        // key: `${subjectCode}-${tier}`, value: lowest rawScore row
        const map = new Map();
        for (const row of dataRows) {
            const subjectCode = row[0];
            const rawScore = Number(row[1]);
            const tier = Number(row[3]);
            if (!subjectCode || !Number.isFinite(rawScore) || !Number.isFinite(tier) || tier <= 0)
                continue;
            const key = `${subjectCode}-${tier}`;
            const existing = map.get(key);
            if (!existing || rawScore < existing.score) {
                map.set(key, { subject: (0, SubjectCodes_1.getSubjectDisplayName)(subjectCode), tier, score: rawScore });
            }
        }
        const uploaded = Array.from(map.values()).sort((a, b) => a.subject.localeCompare(b.subject, 'ko') || a.tier - b.tier);
        if (uploaded.length)
            return uploaded;
        return restoredCutoff ?? [];
    }, [savedRows, restoredCutoff]);
    const cutoffGroupedRows = react_1.default.useMemo(() => {
        const groups = [];
        for (const row of previewTableRows) {
            const last = groups[groups.length - 1];
            if (last && last.subject === row.subject) {
                last.rows.push({ tier: row.tier, score: row.score });
            }
            else {
                groups.push({ subject: row.subject, rows: [{ tier: row.tier, score: row.score }] });
            }
        }
        return groups;
    }, [previewTableRows]);
    const renderSubjectName = (name) => {
        const idx = name.indexOf('(');
        if (idx === -1)
            return react_1.default.createElement(react_1.default.Fragment, null, name);
        return react_1.default.createElement(react_1.default.Fragment, null,
            name.slice(0, idx),
            react_1.default.createElement("br", null),
            name.slice(idx));
    };
    const showErrorPopup = (message) => {
        APP.eventManager.publish(popup_1.TOGGLE_POPUP, {
            component: DeletePopUpLayout_1.DeletePopUpLayout,
            componentProps: {
                deleteContent: [message],
                showCancel: false,
            },
            width: 500,
            isFit: true,
            title: t('assignment.gradeData.uploadTitle'),
        });
    };
    const onDownloadCutoffForm = async () => {
        try {
            if (reportType === 'yigam') {
                await (0, server_1.downloadYigamForm)();
            }
            else {
                // test_id 를 넘겨 서버가 해당 테스트의 과목별 양식을 반환하도록 한다.
                await (0, server_1.downloadCutoffForm)(testId);
            }
        }
        catch (error) {
            showErrorPopup(error instanceof Error ? error.message : t('assignment.reportCardLoadFailed'));
        }
    };
    // const onDownloadQuestionStatsForm = async () => {
    // 	try {
    // 		await downloadQuestionStatsForm();
    // 	} catch (error) {
    // 		showErrorPopup(error instanceof Error ? error.message : t('assignment.reportCardLoadFailed'));
    // 	}
    // };
    const onDownloadSavedData = async () => {
        try {
            await (0, server_1.downloadCutoff)(testId);
        }
        catch (error) {
            showErrorPopup(error instanceof Error ? error.message : t('assignment.reportCardLoadFailed'));
        }
    };
    const onSave = async () => {
        if (isSaveDisabled)
            return;
        const uploadFile = fileList[0];
        if (!uploadFile) {
            showErrorPopup(t('assignment.gradeData.uploadRequired'));
            return;
        }
        setSaveState('saving');
        setErrorMessage('');
        try {
            const response = await (0, server_1.uploadCutoff)({ id: testId, file: uploadFile });
            onSaveSuccess(response.result.raws);
            setFileList([]);
            setSaveState('success');
            setShowSuccessToast(true);
        }
        catch (error) {
            setSaveState('error');
            setErrorMessage(typeof error === 'string' ? error : t('assignment.gradeData.errorText'));
        }
    };
    react_1.default.useEffect(() => {
        APP.eventManager.publish('SHOW_LOADING', isSaving);
        return () => {
            APP.eventManager.publish('SHOW_LOADING', false);
        };
    }, [isSaving]);
    react_1.default.useEffect(() => {
        if (!showSuccessToast)
            return;
        const timer = window.setTimeout(() => {
            setShowSuccessToast(false);
            setSaveState('idle');
        }, 2000);
        return () => window.clearTimeout(timer);
    }, [showSuccessToast]);
    react_1.default.useEffect(() => {
        if (fileList.length > 1) {
            setFileList([fileList[fileList.length - 1]]);
        }
    }, [fileList]);
    react_1.default.useEffect(() => {
        // 파일 제거 시: idle 로 복귀(에러 메시지 해제). (성공 토스트 상태는 보존)
        if (fileList.length === 0 && saveState !== 'success') {
            setSaveState('idle');
            setErrorMessage('');
            return;
        }
        // 파일 재업로드/교체 시: 직전 검토 이상(에러)을 해제해 다시 저장 가능하도록 함.
        if (fileList.length > 0 && saveState === 'error') {
            setSaveState('idle');
            setErrorMessage('');
        }
    }, [fileList]);
    return (react_1.default.createElement(GradeDataManagerStyled, { "$isMobile": isMobile, "$isDesktop": isDesktop, "$hasError": saveState === 'error' },
        react_1.default.createElement("div", { className: "section-block" },
            reportTypeDisplay && (react_1.default.createElement("div", { className: "section-title" },
                "\uC131\uC801\uD45C \uC720\uD615: ",
                reportTypeDisplay)),
            react_1.default.createElement("div", { className: "upload-title-row" },
                react_1.default.createElement("div", { className: "section-title" }, t('assignment.gradeData.uploadTitle')),
                react_1.default.createElement("div", { className: "upload-action-links" },
                    react_1.default.createElement("button", { type: "button", className: "upload-action-link", onClick: onDownloadCutoffForm },
                        react_1.default.createElement(common_1.Icon, { icon: "download", size: isMobile ? 12 : 16 }),
                        t('assignment.gradeData.downloadTemplate')),
                    react_1.default.createElement("button", { type: "button", className: "upload-action-link", onClick: onDownloadSavedData },
                        react_1.default.createElement(common_1.Icon, { icon: "download", size: isMobile ? 12 : 16 }),
                        t('assignment.gradeData.downloadData')))),
            react_1.default.createElement("div", { className: "action-row" },
                react_1.default.createElement(option_1.FileAttach, { id: "teacher-grade-data-upload", className: "upload-file-attach", isRegist: true, isGmk: true, fileList: fileList, setAttachFileList: setFileList, handlerDownload: onDownloadCutoffForm, uploadButtonText: t('assignment.gradeData.uploadFileButton'), extraButton: react_1.default.createElement(common_1.Button, { className: isSaveDisabled ? 'btn_default xmd' : 'btn_tur xmd', text: isSaving ? 'assignment.gradeData.saving' : 'assignment.gradeData.save', onClick: onSave, styles: {
                            buttonWrap: {
                                opacity: isSaveDisabled ? 0.45 : 1,
                                pointerEvents: isSaveDisabled ? 'none' : 'auto',
                            },
                        } }) })),
            react_1.default.createElement("div", { className: "info-wrap" },
                saveState === 'error' && (react_1.default.createElement("p", { className: "error-text" },
                    "\u26A0 ",
                    errorMessage || t('assignment.gradeData.errorText'))),
                hasValidSavedAt && (react_1.default.createElement("div", { className: "saved-at" }, t('assignment.gradeData.lastSavedAt', { savedAt }))))),
        (hasSavedData || hasSavedQuestionStats) && (react_1.default.createElement("div", { className: "preview-grid" },
            hasSavedData && (react_1.default.createElement("div", { className: "saved-data-card" },
                react_1.default.createElement("div", { className: "section-title" }, t('assignment.gradeData.cutoffPreviewTitle')),
                isMobile ? (react_1.default.createElement("div", { className: "mobile-cutoff-list" }, cutoffGroupedRows.map((group) => (react_1.default.createElement("div", { className: "mobile-cutoff-group", key: group.subject },
                    react_1.default.createElement("div", { className: "mobile-cutoff-subject" }, group.subject),
                    group.rows.map(row => (react_1.default.createElement("div", { className: "mobile-cutoff-tier-row", key: row.tier },
                        react_1.default.createElement("span", { className: "mobile-cutoff-label" },
                            row.tier,
                            "\uB4F1\uAE09"),
                        react_1.default.createElement("span", null,
                            row.score,
                            "\uC810"))))))))) : (react_1.default.createElement("table", { className: "saved-table" },
                    react_1.default.createElement("thead", null,
                        react_1.default.createElement("tr", null,
                            react_1.default.createElement("th", null, t('assignment.gradeData.subjectHeader')),
                            react_1.default.createElement("th", null, t('assignment.gradeData.grade')),
                            react_1.default.createElement("th", null, t('assignment.gradeData.scoreHeader')))),
                    react_1.default.createElement("tbody", null, previewTableRows.map((row, rowIndex) => {
                        const isFirstInGroup = rowIndex === 0 || row.subject !== previewTableRows[rowIndex - 1].subject;
                        const rowSpan = isFirstInGroup
                            ? previewTableRows.filter(r => r.subject === row.subject).length
                            : 0;
                        return (react_1.default.createElement("tr", { key: `preview-row-${rowIndex}` },
                            isFirstInGroup && (react_1.default.createElement("td", { rowSpan: rowSpan }, row.subject)),
                            react_1.default.createElement("td", null, row.tier),
                            react_1.default.createElement("td", null, row.score)));
                    })))))),
            hasSavedQuestionStats && (react_1.default.createElement("div", { className: "saved-data-card" },
                react_1.default.createElement("div", { className: "section-title" }, t('assignment.gradeData.questionStatsPreviewTitle')),
                isMobile ? (react_1.default.createElement("div", { className: "mobile-question-list" }, questionStatsGrouped.map(group => {
                    const choiceLabels = ['①', '②', '③', '④', '⑤'];
                    return (react_1.default.createElement("div", { className: "mobile-question-group", key: group.subjectCode },
                        react_1.default.createElement("div", { className: "mobile-question-group-header" },
                            "\uACFC\uBAA9: ",
                            group.subjectName),
                        group.rows.map((row, rowIndex) => {
                            const isShortAnswer = row.choices[0] !== null && row.choices.slice(1).every(c => c === null);
                            // 보기별 반응률이 모두 0(또는 없음)이면 보기 없는 문항(주관식 등)이므로 빈칸 처리
                            const isAllZeroChoice = row.choices.reduce((sum, v) => sum + (Number(v) || 0), 0) === 0;
                            const displayChoices = isAllZeroChoice
                                ? choiceLabels.map(label => ({ label, value: null }))
                                : isShortAnswer
                                    ? [{ label: '주관식', value: row.choices[0] }]
                                    : choiceLabels.map((label, ci) => ({ label, value: row.choices[ci] }));
                            return (react_1.default.createElement("div", { className: "mobile-question-item", key: `mq-${group.subjectCode}-${rowIndex}` },
                                react_1.default.createElement("div", { className: "mobile-question-header" },
                                    react_1.default.createElement("span", { className: "mobile-question-num" },
                                        "\uBB38\uD56D ",
                                        row.questionNum),
                                    react_1.default.createElement("span", { className: "mobile-question-meta" },
                                        "\uC624\uB2F5\uB960 ",
                                        row.correctRate,
                                        "%",
                                        row.rank != null ? ` · 순위 ${row.rank}` : '')),
                                react_1.default.createElement("div", { className: "mobile-choices-grid" }, displayChoices.map(c => (react_1.default.createElement("span", { className: "mobile-choice-item", key: c.label },
                                    react_1.default.createElement("span", { className: "mobile-choice-label" }, c.label),
                                    react_1.default.createElement("span", null, c.value ?? '')))))));
                        })));
                }))) : (react_1.default.createElement("div", { className: "table-scroll-wrap" },
                    react_1.default.createElement("table", { className: "question-stats-table" },
                        react_1.default.createElement("thead", null,
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", { rowSpan: 2 }, t('assignment.gradeData.subjectHeader')),
                                react_1.default.createElement("th", { rowSpan: 2 }, t('assignment.gradeData.questionNumHeader')),
                                react_1.default.createElement("th", { colSpan: 2 }, "\uC624\uB2F5\uB960"),
                                react_1.default.createElement("th", { colSpan: 5 }, "\uB2F5\uC9C0\uBC18\uC751\uB960(%)")),
                            react_1.default.createElement("tr", null,
                                react_1.default.createElement("th", null, "%"),
                                react_1.default.createElement("th", null, t('assignment.gradeData.rankHeader')),
                                react_1.default.createElement("th", null, "\u2460"),
                                react_1.default.createElement("th", null, "\u2461"),
                                react_1.default.createElement("th", null, "\u2462"),
                                react_1.default.createElement("th", null, "\u2463"),
                                react_1.default.createElement("th", null, "\u2464"))),
                        react_1.default.createElement("tbody", null, questionStatsGrouped.flatMap(group => group.rows.map((row, rowIndex) => {
                            const isShortAnswer = row.choices[0] !== null && row.choices.slice(1).every(c => c === null);
                            // 보기별 반응률이 모두 0(또는 없음)이면 보기 없는 문항(주관식 등)이므로 빈칸 처리
                            const isAllZeroChoice = row.choices.reduce((sum, v) => sum + (Number(v) || 0), 0) === 0;
                            return (react_1.default.createElement("tr", { key: `qs-${group.subjectCode}-${rowIndex}` },
                                rowIndex === 0 && (react_1.default.createElement("td", { rowSpan: group.rows.length, className: "subject-cell" }, renderSubjectName(group.subjectName))),
                                react_1.default.createElement("td", null, row.questionNum),
                                react_1.default.createElement("td", null, row.correctRate),
                                react_1.default.createElement("td", null, row.rank ?? ''),
                                isAllZeroChoice ? (row.choices.map((_, ci) => (react_1.default.createElement("td", { key: ci })))) : isShortAnswer ? (react_1.default.createElement("td", { colSpan: 5, style: { textAlign: 'center' } }, row.choices[0])) : (row.choices.map((val, ci) => (react_1.default.createElement("td", { key: ci }, val ?? ''))))));
                        })))))))))),
        showSuccessToast && (react_1.default.createElement("div", { className: "success-toast" },
            react_1.default.createElement(common_1.Icon, { icon: "check-circle", size: 22, fill: "#8f7bff" }),
            t('assignment.gradeData.successText')))));
});
